import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      pushedFields: [],
      allowAllFieldTypes: false,
      allowedFieldTypes: ['list'],
      renderDynamicField: true,
    };
  },
  props: ['category', 'subcategory'],
  computed: {
    ...mapGetters([
      'attributeTypes',
    ]),
    atSelectType() {
      return this.attributeTypes.find(
        item => (this.allowAllFieldTypes || this.allowedFieldTypes.indexOf(item.type) !== -1)
          && this.pushedFields.indexOf(item) === -1);
    },
    atSelectTypePath() {
      const path = [];

      if (this.subcategory && this.subcategory.length) {
        path.push(this.$t(`subcategory.${this.category.key}.${this.subcategory.key}`));
      }
      const attributeValues = this.pushedFields
        // .filter(item => this.getFieldValue(item))
        .map((item) => {
          const val = this.getFieldValue(item);
          return val ? val.name || val.value : this.$t(`filter.${item.key}.label`);
        });

      return [...path, ...attributeValues].join(' > ');
    },
  },
  methods: {
    setSelectFieldValue(atItem, atType) {
      this.pushedFields.push(atType);
      this.renderDynamicField = false;
      this.setFieldValue(atItem, atType)
        .then(() => {
          this.$nextTick(() => {
            this.renderDynamicField = true;
            if (!this.atSelectType) {
              this.$emit('reached-end');
              this.reset();
            }
          });
        });
    },
    reset() {
      this.pushedFields = [];
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/filters/mobile-dynamic-fields.js